// Greeting the chat document is seeded with; hidden on screen when the welcome panel already greets the user.
export const AUTO_GREETING_TEXT = "Hello, how can I help you?";

// Default welcome-screen copy, used when a brand hasn't set Welcome_Text on its Shopify/<shopId> doc.
export const DEFAULT_WELCOME_TEXT = "Hey there! 👋 I'm your hair-care sidekick. Tell me a bit about your hair and I'll help you figure out your exact hair type!";
export const DEFAULT_WELCOME_TEXT_WITH_PHOTO = "Hey there! 👋 I'm your hair-care sidekick. Upload a photo of your hair and I'll help you figure out your exact hair type!";

// Returns the brand's welcome text, or the default copy that matches whether photo upload is enabled.
export function resolveWelcomeText(brandWelcomeText, imageUploadEnabled) {
  if (brandWelcomeText) return brandWelcomeText;
  return imageUploadEnabled ? DEFAULT_WELCOME_TEXT_WITH_PHOTO : DEFAULT_WELCOME_TEXT;
}
